import { CharacterAddPerk, CharacterRemovePerk, CharacterSavePerk } from "../actions/CharacterPerkActions";
import { CharacterState } from "../CharacterStore.State";
import { CharacterReducerHelpers } from "./CharacterReducerHelpers";

const savePerk = (state: CharacterState, action: CharacterSavePerk): CharacterState => {
    const { characterId, reference } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    const perk = character.perks.find(p => p.id == reference.id);
    if (perk == undefined) {
        console.error('Attempt to save nonexistent perk.');
        return state;
    }

    const newPerk = { ...perk, instanceId: reference.instanceId };
    const pendingProperties = { ...character.pendingProperties }
    delete pendingProperties[reference.instanceId];
    const newCharacter = {
        ...character,
        pendingProperties,
        perks: [...character.perks.filter(p => p.instanceId != perk.instanceId), newPerk]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const addPerk = (state: CharacterState, action: CharacterAddPerk): CharacterState => {
    const { characterId, reference } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    if (character.perks.find(p => p.id == reference.id)) {
        console.error('Attempt to add duplicate perk.');
        return state;
    }

    const newCharacter = { ...character, perks: [...character.perks, reference] };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const removePerk = (state: CharacterState, action: CharacterRemovePerk): CharacterState => {
    const { characterId, perkInstanceId } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    if (!character.perks.any(perk => perk.instanceId == perkInstanceId)) {
        console.error('Attempt to remove nonexistent perk.');
        return state;
    }

    const newCharacter = { ...character, perks: character.perks.filter(perk => perk.instanceId != perkInstanceId) };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

export const CharacterPerkReducers = {
    savePerk,
    addPerk,
    removePerk,
}